import * as S from './styles';

type Props = {
  name: string;
  image: string;
  alt?: string;
  selected: boolean;
  onSelect?: () => void;
}

export function TipoPagamentoCard ({ name, image, alt, onSelect, selected }: Props) {
  return (
    <S.Container
      onClick={onSelect}
      selected={selected}
    >
      <S.Image src={image} alt={alt} />
      <S.Title selected={selected}>{name}</S.Title>
    </S.Container>
  )
}
